import React, { forwardRef, memo, useImperativeHandle, useMemo, useRef } from "react";

import useStyles from "./styles";

import { TreeSelectorNodeGroup } from "./TreeSelectorNodeGroup";
import { useTranslation } from "react-i18next";

function GetFilteredPathsFor (collection, text) {

  return (collection || []).reduce((acc, item) => {

    const match = item.text.toLowerCase().includes(text);
    const matchChildren = GetFilteredPathsFor(item.children, text);

    acc = [...acc, ...matchChildren];
    if (match || !!matchChildren.length) {
      acc = [...acc, item.path];
    }

    return acc;
  }, []);

}

const TreeSelectorComponent = ({
  nodes,
  value,
  invariants,
  showLoading = true,
  loadingText = '',
  showNoData = true,
  noDataText = '',
  showLoadingOnRoot = false,
  showNoDataOnRoot = false,
  disableStoresIcon=false,
  pagination = null,
  filterText = null,
  watchForChange = [],
  checkDisabled = (node: any) => false,
  onNodeExpanded = (node: any) => {},
  onChange = (node: any[]) => {},
  onNextNodesPage = (node: any) => {},
}: any, ref: any) => {

  const groupConfig = {
    nodes,
    value,
    invariants,
    showLoading,
    loadingText,
    showNoData,
    noDataText,
    pagination,
    showLoadingOnRoot,
    showNoDataOnRoot,
    checkDisabled,
    onNextNodesPage,
    watchForChange,
    disableStoresIcon
  }

  const { t } = useTranslation();

  noDataText = t('app.common.noItemsFound');
  loadingText = t('app.common.loading');

  const classes = useStyles();
  const refNodeGroup = useRef<any>(null);

  const handleChange = (node: any, value: any[]) => {
    onChange(value);
  };

  const visibleNodes = useMemo(() => GetFilteredPathsFor(nodes, filterText), [filterText, nodes]);

  const checkTreeNodeVisibility = (node: any) => {
    return !filterText?.length || visibleNodes.includes(node.path);
  };

  useImperativeHandle(ref, () => ({
    collapseAll: () => refNodeGroup.current?.collapseAll(),
    expandAll: () => refNodeGroup.current?.expandAll()
  }));

  return (
    <TreeSelectorNodeGroup
      {...groupConfig}
      ref={refNodeGroup}
      className={classes.root}
      parentCheckboxWrapperClassName={classes.parentCheckboxWrapper}
      checkVisibility={checkTreeNodeVisibility}
      onNodeExpanded={onNodeExpanded}
      onChange={handleChange}
    />
  );
};

export const TreeSelector = memo(forwardRef(TreeSelectorComponent));
